<script>
import { store } from '../../functions/mixins';
import UiHeadline from '../ui/Headline';
import UiSubheader from '../ui/Subheader';
import UiStepper from '../ui/Stepper';
import UiLoading from '../ui/Loading';
import UiScrollbar from '../ui/Scrollbar';
import deepEqual from 'deep-equal';
import {
    pressengerControl, getNotificationImageURL, getAdvertisementImageURL, getAdvertisementImageBigURL,
} from '../../functions/sdk';
import * as crossPopup from '../../functions/crossPopup';

export default {
    mixins: [store],
    props: {
        value: Object,
        skipStep: Function,
    },
    components: {
        UiHeadline,
        UiSubheader,
        UiLoading,
        UiScrollbar,
    },
    data: () => ({
        data: null,
        items: [],
        loading: false,
        uploading: false,
        uploadError: false,
        uploadDuplicateFilename: false,
    }),
    computed: {
        sorted() {
            return this.items === null ? [] : this.items.sort((a, b) => {
                const aid = a.id === null ? Number.MAX_SAFE_INTEGER : a.id;
                const bid = b.id === null ? Number.MAX_SAFE_INTEGER : b.id;
                return bid - aid;
            }).sort((a, b) => {
                if (a.backgroundFileName && b.backgroundFileName) return 0;
                if (!a.backgroundFileName && !b.backgroundFileName) return 0;
                if (a.backgroundFileName) return -1;
                if (b.backgroundFileName) return 1;
            });
        },
    },
    created() {
        this.data = Object.assign({}, this.value);
        this.fetch();
    },
    methods: {
        fetch() {
            this.loading = true;
            pressengerControl.getAdvertisementImages().then(items => {
                this.items = items;
                this.loading = false;
            }).catch(() => {
                setTimeout(() => {
                    this.fetch();
                }, 2000);
            });
        },
        openStudio() {
            crossPopup.openPopup('https://studio.ntatic.now.sh/index.html', (type, payload, ID) => {
                switch (type) {
                    case 'IMAGE_UPLOAD':
                        const blob = new Blob(payload.parts, payload.options);
                        const file = new File([blob], `${Date.now()}-studio.png`);
                        pressengerControl.uploadAdvertisementImage(file, true).then(uploaded => {
                            crossPopup.dispatch(ID, 'IMAGE_UPLOAD_DONE', {
                                success: true,
                                url: getAdvertisementImageURL(uploaded.groupId, uploaded.fileName),
                            });
                            this.data.advertisementImage = uploaded;
                            this.items.push(uploaded);
                        }).catch(() => {
                            dispatch(ID, '_DONE', {
                                success: false,
                                url: false,
                            });
                        });
                        break;
                }
            }, (this.isPushwize || this.isInflugamers) ? 'Studio StudioFull' : 'Studio');
        },
        upload() {
            this.uploadError = false;
            this.uploadDuplicateFilename = false;
            const files = event.target.files || event.dataTransfer.files;
            if (!files || !files[0]) {
                return;
            }
            if (this.checkIsDuplicateFilename(files[0].name)) {
                this.uploadError = true;
                this.uploadDuplicateFilename = true;
                return;
            }
            const image = new File([files[0]], `${Date.now()}-${files[0].name.replace(/[^\w.-]+/g, '_')}`)
            this.uploading = true;
            pressengerControl.uploadAdvertisementImage(image).then(uploaded => {
                this.data.advertisementImage = uploaded;
                this.items.push(uploaded);
            }).catch(() => {
                this.uploadError = true;
            }).finally(() => {
                this.uploading = false;
            });
        },
        select(item) {
            if (this.data.advertisementImage && this.data.advertisementImage.id === item.id) {
                this.data.advertisementImage = null;
            } else {
                this.data.advertisementImage = item;
            }
        },
        getImageSrc(item) {
            if (item.backgroundFileName) {
                return getAdvertisementImageBigURL(item.groupId, item.fileName);
            } else {
                return getAdvertisementImageURL(item.groupId, item.fileName);
            }
        },
        onPrevClicked() {
            if (this.loading || this.items.length === 0) {
                return;
            }
            if (this.data.advertisementImage === null) {
                this.data.advertisementImage = this.sorted[0];
                return;
            }
            let index = 0;
            this.sorted.forEach((item, i) => {
                if (item.id === this.data.advertisementImage.id) {
                    index = i;
                }
            });
            index--;
            if (index < 0) {
                index = this.sorted.length - 1;
            }
            this.data.advertisementImage = this.sorted[index];
        },
        onNextClicked() {
            if (this.loading || this.items.length === 0) {
                return;
            }
            if (this.data.advertisementImage === null) {
                this.data.advertisementImage = this.sorted[0];
                return;
            }
            let index = 0;
            this.sorted.forEach((item, i) => {
                if (item.id === this.data.advertisementImage.id) {
                    index = i;
                }
            });
            index++;
            if (index >= this.sorted.length) {
                index = 0;
            }
            this.data.advertisementImage = this.sorted[index];
        },
        friendlyName(filename, trimExt = true) {
            let name = filename;
            const prefix = name.match(/^[0-9]+-/gi);
            const ext = name.match(/.[a-z]+$/gi);
            if (prefix) {
                name = name.substring(prefix[0].length);
            }
            if (trimExt, ext) {
                name = name.substring(0, name.length - ext[0].length)
            }
            return name;
        },
        checkIsDuplicateFilename(filename) {
            const ffn = this.friendlyName(filename)
            return !!this.items.find(i => this.friendlyName(i.fileName) === ffn);
        },
    },
    destroyed() {
        // crossPopup.closeAllInstances();
    },
    watch: {
        value: {
            deep: true,
            handler(nextVal) {
                if (!deepEqual(nextVal, this.data)) {
                    this.data = Object.assign({}, nextVal);
                }
            }
        },
        data: {
            deep: true,
            handler: function(nextVal) {
                if (!deepEqual(nextVal, this.value)) {
                    this.$emit('input', Object.assign({}, nextVal));
                }
            }
        },
    },
}
</script>

<template>
    <div class="StepTransitions">
        <ui-loading v-if="loading || uploading" />
         <template v-else>
            <div class="Grid" style="padding-right: 20px; margin-bottom: 50px;" v-if="!isUploadDisabled">
                <div :class="['GridItem', 'UploadButton', 'DisableHover', {Error: uploadError}]" @click="$refs.uploader.click()">
                    <div class="Toolbar">
                        <span>&nbsp;</span>
                    </div>
                    <div class="ImageWrapper">
                        <span class="GridItemErrorMessage" v-if="uploadDuplicateFilename">{{ $t('sendPressageView.uploadErrorDuplicateFilename') }}</span>
                    </div>
                    <div class="GridItemHint" v-html="$t('sendPressageView.stepAndroidAdvertisementImageUploadHint')" />
                </div>
            </div>
            <ui-scrollbar :height="isUploadDisabled ? 420 : 220">
                <div class="Grid">
                    <div
                        v-for="(i, index) in sorted"
                        :class="{
                            GridItem: true,
                            Active: data.advertisementImage && i.id === data.advertisementImage.id,
                            NoBorderLeft: (index) % 4 !== 0,
                            NoBorderTop: index > 3,
                        }"
                        :key="i.id"
                        @click="select(i)"
                    >
                        <div class="Toolbar">
                            <span>{{ friendlyName(i.backgroundFileName ? i.backgroundFileName : i.fileName) }}</span>
                        </div>
                        <div class="ImageWrapper AddNoise">
                            <img :src="getImageSrc(i)" :alt="friendlyName(i.backgroundFileName ? i.backgroundFileName : i.fileName)" />
                        </div>
                        <div class="Check">
                            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="16.5" height="13.5" viewBox="0 0 16.5 13.5" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.038 2.741c.298-.305.462-.708.462-1.133 0-.43-.164-.833-.462-1.138a1.55 1.55 0 00-2.222 0L4.869 9.616 2.684 7.385a1.548 1.548 0 00-2.222 0A1.614 1.614 0 000 8.522c0 .429.164.832.462 1.133l3.293 3.365a1.55 1.55 0 002.222 0"/></svg>
                        </div>
                    </div>
                    <div class="GridFullLoading" v-if="uploading">
                        <ui-loading />
                    </div>
                </div>
            </ui-scrollbar>
         </template>
         <input
            type="file"
            ref="uploader"
            name="file"
            accept="*"
            style="display: none"
            @change="upload"
        />
    </div>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.Grid
    display flex
    justify-content flex-start
    align-items flex-start
    align-content flex-start
    flex-wrap wrap
    min-height 100%
    box-sizing border-box
    position relative
    .GridItem
        display flex
        flex-direction column
        justify-content center
        align-items center
        width 25%
        position relative
        border 1px solid $cBorder
        box-sizing border-box
        padding 20px
        transition .3s all
        background rgba(255,255,255,.4)
        cursor: pointer;
        &.StudioButton
            background-color #2B2A62
            background-image url(/static/img/toolbox2/studio_wide.png)
            background-size contain
            background-repeat no-repeat
            background-position center center
        &.UploadButton
            background-color #2B2A62
            background-image url(/static/img/toolbox2/upload_transparent.png)
            background-size 64px
            background-repeat no-repeat
            background-position center center
            &.Error
                background-color $cError
        &.NoBorderTop
            border-top none
        &.NoBorderLeft
            border-left none
        .Toolbar
            font-size 12px
            font-weight 600
            color $cPrimary
            align-self flex-start
            overflow hidden
            white-space nowrap
            max-width 100%
        .ImageWrapper
            overflow hidden
            height 110px
            display flex
            flex-direction column
            justify-content center
            align-items center
            &.AddNoise
                background-image url(/static/img/bg_noise.png)
                background-size cover
            img
                max-width 100%
                max-height 110px
            .GridItemErrorMessage
                display inline-block
                margin-top 20px
                font-weight 500
                font-size 12px
                text-align center
                transition .3s all
            .GridItemUploadImage
                width 100%
                height 100%
                max-width 32px
                max-height 32px
                fill: $cPrimary
                transition .3s all
        .Check
            position absolute
            opacity 0
            top 0
            left 0
            right 0
            bottom 0
            background rgba(255,255,255,.7)
            display flex
            align-items center
            justify-content center
            transition .3s all
            svg
                transform scale(2)
            path
                fill $cAccent
        .GridItemHint
            position absolute
            padding 20px
            background #fff
            border 2px solid $cBorder
            color $cPrimary
            font-size 12px
            font-weight 400
            transform: translate(-50%, -50%) scale(0);
            transition .3s all
            z-index 9999
            left: 50%;
            top: 100%;
            width: calc(100% - 40px);
            min-width 300px
        &:hover
            .GridItemHint
                transform: translate(-50%, 0) scale(1);
        &.Active
            background #fff
            transform scale(1.08)
            z-index 2
            border-color white
            box-shadow 0 40px 100px rgba(0,0,0,.2)
            .Check
                opacity 1
            img
                filter blur(3px)
        &.Error
            .ImageWrapper
                .GridItemErrorMessage
                    color $cError
                .GridItemUploadImage
                    fill $cError
        &:hover:not(.DisableHover)
            background #fff
    .GridFullLoading
        position absolute
        width 100%
        height 100%
        top 0
        left 0
        background rgba(255,255,255,.4)
        display flex
        align-items center
        justify-content center
        z-index 10
    &.ColumnHalf
        .GridItem
            width 50%
            .ImageWrapper
                height 80px
            .ImageWrapper img
                max-height 80px
                max-width 1000px

.StepTransitions .Scrollbar
    padding 40px 70px 150px 70px !important
    margin -40px -50px -150px -70px
    .ps__scrollbar-y-rail
        right 50px !important
        top 50px !important
</style>
